import React, {useState} from "react";
import {
    Button,
    Field,
    makeStyles,
    Menu,
    MenuButton,
    MenuItem,
    MenuList,
    MenuPopover,
    MenuTrigger,
    Spinner,
    Textarea,
} from "@fluentui/react-components";
import {Send16Filled} from "@fluentui/react-icons";
import {insertText} from "../../taskpane";
import {useAssistantService} from "../../../utils/services/http.service";

const inspirations = [
    "Génère moi un modèle de lettre de mise en demeure pour cabinet d'avocat",
    "Génère moi un modèle de lettre de contestation pour cabinet d'avocat ",
];

const useStyles = makeStyles({
    page: {
        display: "flex",
        flexDirection: "column",
        alignItems: "stretch",
        width: "100%",
        maxWidth: "100%",
        minWidth: 0,
        boxSizing: "border-box",
        rowGap: "12px",
    },
    button: {
        width: "100%",
        maxWidth: "100%",
        minWidth: 0,
        height: "auto",
        whiteSpace: "normal",
        justifyContent: "center",
        columnGap: "8px",
    },
    buttonLabel: {
        minWidth: 0,
        whiteSpace: "normal",
        overflowWrap: "anywhere",
    },
    full_width: {
        width: "100%",
        maxWidth: "100%",
        minWidth: 0,
    },
    menuItem: {
        height: "auto",
        maxWidth: "100%",
        whiteSpace: "normal",
        overflowWrap: "anywhere",
    },
});

function Modeles() {
    const styles = useStyles();
    const {chat} = useAssistantService();

    const [progress, setProgress] = useState(false);
    const [inputValue, setInputValue] = useState("");

    const handleTextChange = async (event: React.ChangeEvent<HTMLTextAreaElement>) => {
        setInputValue(event.target.value);
    };

    const setInspiration = (index: number) => {
        return () => {
            setInputValue(inspirations[index]);
        };
    };

    const generateModele = async () => {
        setProgress(true);

        chat(inputValue)
            .then(async (reponse) => {
                setProgress(false);
                await insertText(reponse);
            });
    };

    return (
        <div className={styles.page}>
            <Field label="Demander à Zéphyr de me générer un document" size="small" className={styles.full_width}>
                <Textarea className={styles.full_width} rows={8} value={inputValue} onChange={handleTextChange}
                          placeholder="Commencez à écrire ici ..."/>
            </Field>
            <Menu positioning={{position: "below", align: "start", fallbackPositions: ["above"], autoSize: "width"}}>
                <MenuTrigger disableButtonEnhancement>
                    <MenuButton className={styles.button}>
                        <span className={styles.buttonLabel}>J'ai besoin d'inspiration ...</span>
                    </MenuButton>
                </MenuTrigger>

                <MenuPopover>
                    <MenuList>
                        <MenuItem className={styles.menuItem} onClick={setInspiration(0)}>Modèle de lettre de mise en demeure</MenuItem>
                        <MenuItem className={styles.menuItem} onClick={setInspiration(1)}>Modèle de lettre de contestation</MenuItem>
                    </MenuList>
                </MenuPopover>
            </Menu>
            <Button className={styles.button} appearance="primary" onClick={generateModele}>
                <Send16Filled/>
                <span className={styles.buttonLabel}>Envoyer ma demande à Zéphyr</span>
            </Button>
            {progress && <Spinner size="small"/>}
        </div>
    );
}

export default Modeles;
